export default __webpack_public_path__ + "static/media/avatar1.53581ed3.png";